<template>
  <Navbar />
  <SubnavFilters />
  <EmailConsent />
  <WelcomeMessage :message="schoolStore.school?.welcome_message" />
  <main>
   

    <div class="container h-100">
      <div class="tab-content h-100" id="pills-tabContent">
        <ConferenceList :school="schoolStore.school" />
        <Agenda :school="schoolStore.school" />
      </div>
    </div>
  </main>
  
  <!-- Confirmation Modal -->
  <AgendaConfirmationModal 
    :show="agendaStore.showConfirmationModal"
    @update:show="agendaStore.showConfirmationModal = $event"
  />
</template>

<script setup>
import { onMounted } from "vue";
import Navbar from "@/components/parent/Navbar.vue";
import SubnavFilters from "@/components/parent/SubnavFilters.vue";
import EmailConsent from "@/components/parent/EmailConsent.vue";
import WelcomeMessage from "@/components/parent/WelcomeMessage.vue";
import Agenda from "@/components/parent/Agenda.vue";
import ConferenceList from "@/components/parent/ConferenceList.vue";
import AgendaConfirmationModal from "@/components/parent/AgendaConfirmationModal.vue";
import { useConferenceStore } from "@/stores/parent/conference";
import { useAgendaStore } from "@/stores/parent/agenda";
import { useSchoolStore } from "@/stores/school";
import { useRoute } from "vue-router";
import { getMeetingUrlProperty } from "@/utils/meetingTypes";
const route = useRoute();

const conferenceStore = useConferenceStore();
const agendaStore = useAgendaStore();
const schoolStore = useSchoolStore();
console.log("mounted");

const agendaMeetingTypesUpdate = async () => {
  // update meeting types and get generated links when not available
  const missing = [];
  const isMissing = (meeting) => {
    const meetingProperty = getMeetingUrlProperty(meeting.meeting_types, meeting);
    const url = meeting[meetingProperty];
    if (
      meeting?.meeting_type == "virtual" &&
      meeting?.meeting_types?.virtual_type &&
      meeting?.meeting_types?.virtual_type != "url" &&
      !url
    ) {
      return true;
    }
    return false;
  };
  // update meeting types when only one is available
  for (const meeting of agendaStore.agenda) {
    const count = Object.values(meeting?.meeting_types || {})
      .filter((v) => typeof v == "boolean")
      .reduce((pre, curr) => pre + +curr, 0);
    if (count == 1) {
      const meeting_type = Object.entries(meeting?.meeting_types || {}).find(
        (i) => i[1] == true
      )?.[0];
      if (meeting_type && meeting_type != meeting.meeting_type) {
        const meeting_detail = {
          pta_id: meeting.pta_id,
          meeting_type
        };
        await agendaStore.saveDetails(meeting_detail);
        meeting.meeting_type = meeting_type;
      }
    }
  }
  for (const meeting of agendaStore.agenda) {
    if (isMissing(meeting)) missing.push(meeting.pta_id);
  }

  if (missing.length) {
    console.log("some of the meetings don't have links, will request update in 30 sec");
    setTimeout(async () => {
      await agendaStore.fetchAgenda();
      const missingMeetings = agendaStore.agenda.filter(
        (m) => missing.includes(m.pta_id) && isMissing(m)
      );
      for (const meeting of missingMeetings) {
        let meeting_type = meeting.meeting_type;
        const count = Object.values(meeting?.meeting_types || {})
          .filter((v) => typeof v == "boolean")
          .reduce((pre, curr) => pre + +curr, 0);
        if (count == 1) {
          meeting_type = Object.entries(meeting?.meeting_types || {}).find((i) => i[1] == true)[0];
        }
        const meeting_detail = {
          pta_id: meeting.pta_id,
          meeting_type
        };
        await agendaStore.saveDetails(meeting_detail);
      }
      setTimeout(() => agendaStore.fetchAgenda(), 5 * 1000);
    }, 10 * 1000);
  }
};

onMounted(() => {
  try {
    agendaStore.fetchAgenda().then(() => {
      console.log("Agenda Loaded");
      agendaMeetingTypesUpdate();
    });
    conferenceStore.fetchConferences().then(() => {
      console.log("Conference Data Loaded");
    });
  } catch (e) {
    console.log(e);
  }
  console.log("do we have a school loaded");
  if (schoolStore.school == null || schoolStore.school?.school_id == undefined) {
    if (route.params.account != null && route.params.account != "") {
      schoolStore.fetchSchool(route.params.account).then(() => {
        console.log("School found");
      });
    } else {
      window.location.href = "https://www.ptcwizard.com";
    }
  }
  
  // Check if there's a pending confirmation and show modal
  if (agendaStore.pendingConfirmation) {
    agendaStore.showConfirmationModal = true;
    agendaStore.pendingConfirmation = false;
  }
});
</script>
